import InsertDriveIFileIcon from '@/components/assets/InsertDriveIFileIcon'
import { Box } from '@/components/ui/box'
import { Text } from '@/components/ui/typography'

const SummarizeQuestionMarkdown = ({ value }: { value: string }) => {
    if (!value.startsWith('Summarize')) {
        return null
    }
    const [command, ...fileParts] = value.split(' ')
    const fileList = fileParts.join(' ')

    const files = fileList.split(',')

    return (
        <Box>
            <Box>{command}:</Box>
            {files.map((file, index) => (
                <Box key={index} mt="16px" display="flex" alignItems="center">
                    <InsertDriveIFileIcon color="var(--chakra-colors-white)" style={{ height: '16px' }} />
                    <Text ml="4px" fontSize="14px" letterSpacing="0.25px">
                        {file.trim()}
                    </Text>
                </Box>
            ))}
        </Box>
    )
}

export default SummarizeQuestionMarkdown
